module.exports = __webpack_public_path__ + "static/media/zamygo_partner_US embassy Korean.51a22c03.jpg";